import { BusinessAction } from "../api/rbac/types";
import { UserDetails } from "../context/UserContext/UserContext";

export const rbacCheck = (
  isRBACEnabled: boolean,
  user: UserDetails | undefined,
  businessAction: BusinessAction
) => !isRBACEnabled || !!user?.isAuthorizedTo(businessAction);
